@if (isInputLike) {
  <div class="w-full h-40 flex items-center" (click)="openMenu()">
    @if (pickedVal) {
      <span class="flex items-center justify-between w-full">
        {{ pickedVal }}
        <mat-icon svgIcon="close" (click)="clearValue($event)" />
      </span>
    }
  </div>
}

@let filteredRecords = filteredRecords$ | async | slice: 0 : 100;
<div #menuTrigger [matMenuTriggerFor]="menu"></div>
<mat-menu #menu class="bd-menu inline-editor-time-zone-menu tooltips-with-theme">
  <div class="searchbox">
    <input
      #filterInput
      [formControl]="searchFormCtrl"
      autocomplete="off"
      name="search-input"
      placeholder="Search existing value"
      class="p-12 rounded search-input"
      type="text"
      (click)="preventEventAction($event)"
    />
  </div>
  <div class="max-h-[320px] overflow-auto">
    @for (record of filteredRecords; track record) {
      <button mat-menu-item class="!h-auto" (click)="selectRecord($event, record)">
        <div class="record">
          <div
            class="record-value truncate"
            [ngClass]="{ 'opacity-[0.48]': !record.value }"
            [blazeTooltip]="record.label"
          >
            {{ record.label }}
          </div>
        </div>
      </button>
    }
    @if (!filteredRecords?.length) {
      <button class="empty-list-notification"> No values to select </button>
    }
  </div>
</mat-menu>
